export const filtersPropMapper = {
  deadlineMonthsMinimum: 'deadlineMonths',
  deadlineMonthsMaximum: 'deadlineMonths',
  legacyAmountMinimum: 'minimumApplication',
  legacyAmountMaximum: 'maximumApplication',
  legacyInitialApplicationMinimum: 'minimumApplication',
  legacyInitialApplicationMaximum: 'minimumApplication',
  legacyMonthlyMinApplication: 'monthlyMinimumApplication',
} as const;

export enum PublicOfferTypes {
  NOT_SET = 0,
  EQUITY_FIXED = 10,
  EQUITY_MAX_VALUE_FOREACH = 11,
  DEB_MINIMUM_REMUNERATION = 20,
  DEB_FIXED = 21,
  DEB_MAX_VALUE_FOREACH = 22,
  CRI_MINIMUM_REMUNERATION = 30,
  CRA_MINIMUM_REMUNERATION = 40,
  COE_FIXED = 50,
  FII_MINIMUM_REMUNERATION = 60,
  FII_FIXED = 61,
  FIDC_FIXED = 70,
}
